import React from 'react';
import { CpuIcon, NetworkIcon, WorkflowIcon, SettingsIcon } from 'lucide-react';
export function AICapabilitiesSection() {
  const capabilities = [{
    icon: <CpuIcon className="w-8 h-8" data-id="element-104" />,
    title: 'GPU Cluster Availability',
    description: 'High-performance NVIDIA GPU clusters configured specifically for deep learning and complex neural network training.'
  }, {
    icon: <NetworkIcon className="w-8 h-8" data-id="element-105" />,
    title: 'Model Training Infrastructure',
    description: 'Distributed training environments that scale seamlessly from initial prototypes to massive production models.'
  }, {
    icon: <WorkflowIcon className="w-8 h-8" data-id="element-106" />,
    title: 'Data Pipeline Management',
    description: 'Robust infrastructure for ETL, real-time streaming, and batch processing of massive datasets.'
  }, {
    icon: <SettingsIcon className="w-8 h-8" data-id="element-107" />,
    title: 'MLOps Support',
    description: 'Comprehensive CI/CD pipelines for machine learning, including model versioning, monitoring, and automated deployment.'
  }];
  return <section id="ai-ml" className="py-24 lg:py-32 bg-ucensys-navy relative overflow-hidden" data-id="element-108">
      {/* Abstract Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-ucensys-teal/5 blur-[150px] rounded-full pointer-events-none" data-id="element-109"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-110">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-111">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-112">
            Purpose-Built for Artificial Intelligence
          </h2>
          <p className="text-lg font-body text-text-secondary" data-id="element-113">
            From prototype to production — train, deploy, and scale your AI
            models on dedicated infrastructure engineered for cognitive
            computing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-114">
          {capabilities.map((cap, index) => <div key={index} className="relative bg-ucensys-card border border-border-color rounded-xl p-8 hover:border-ucensys-teal/50 transition-colors group overflow-hidden" data-id="element-115">
              {/* Top Accent Line */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-ucensys-teal to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-116"></div>

              <div className="w-14 h-14 rounded-xl bg-ucensys-navy border border-border-color flex items-center justify-center text-ucensys-teal mb-6 shadow-teal-glow" data-id="element-117">
                {cap.icon}
              </div>
              <h3 className="text-xl font-heading font-semibold text-white mb-4" data-id="element-118">
                {cap.title}
              </h3>
              <p className="text-text-secondary font-body text-sm leading-relaxed" data-id="element-119">
                {cap.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}